import type { AppState } from '@app/icare/state/app'
import type { StateCreator } from 'zustand'

export interface UISlice {
  sidebarExpanded: boolean
  setSidebarExpanded: (expanded: boolean) => void
  toggleSidebar: () => void
  locked: boolean
  setLocked: (locked: boolean) => void
}

const readInitialSidebarExpanded = (): boolean => {
  if (typeof window === 'undefined') return true
  try {
    const stored = localStorage.getItem('app')
    if (stored) {
      const parsed = JSON.parse(stored) as { state?: { sidebarExpanded?: boolean } }
      return parsed.state?.sidebarExpanded ?? true
    }
  } catch {}
  return true
}

export const createUISlice: StateCreator<AppState, [], [], UISlice> = (set, get) => ({
  sidebarExpanded: readInitialSidebarExpanded(),
  setSidebarExpanded: expanded => {
    if (get().sidebarExpanded === expanded) return
    set(() => ({
      sidebarExpanded: expanded,
    }))
  },
  toggleSidebar: () =>
    set(state => ({
      sidebarExpanded: !state.sidebarExpanded,
    })),
  locked: false,
  setLocked: locked =>
    set(() => ({
      locked,
    })),
})
